<template>
  <section>
    <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :model-css="{ width: '800px', height: '349px', padding: '0' }" :show-close="true" :error-msg="errorMsg" :close-image="closeImg" :close-css="{ top: '-18px', right: '-18px' }" @close="closeDialog">
      <div class="dialog-content">
        <p class="title">{{ errorMsg.title }}</p>
        <p class="text">{{ errorMsg.content }}</p>
      </div>
    </sys-dialog>
    <sys-dialog v-show="h5DialogVisible" :close-image="closeImg" :bgi="dialogBgi" :show-close="true" :error-msg="errorMsg" @close="closeDialog" />
    <sys-loading :loading="loading" />
    <div class="container" v-if="!isMobile">
      <img class="title" src="../assets/football/pc/title.png" />
      <div class="main">
        <div class="form">
          <div class="tag">
            <div class="tag-item reg" :class="isRegisterAction ? 'reg-active' : ''" @click="isRegisterAction = true">
              <template v-if="!isRegisterAction">ĐĂNG KÝ</template>
            </div>
            <div class="tag-item login" :class="!isRegisterAction ? 'login-active' : ''" @click="isRegisterAction = false">
              <template v-if="isRegisterAction">ĐĂNG NHẬP</template>
            </div>
          </div>
          <section class="form-content">
            <div class="form-input">
              <img src="../assets/sport/icon-user.png" />
              <input v-model="form.userName" onkeyup="value=value.replace(/[^\w./]/ig,'')" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
            </div>
            <div class="form-input" v-show="isRegisterAction">
              <img src="../assets/sport/icon-phone.png" />
              <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" onpaste="value=value.replace(/^\D/, '')" />
            </div>
            <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
              <img src="../assets/sport/icon-password.png" />
              <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
            </div>
            <div class="form-input" v-show="isRegisterAction">
              <img src="../assets/sport/icon-email.png" />
              <input v-model="form.email" autocomplete="off" placeholder="Email" />
            </div>
            <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;">
              <input v-model="form.verificationCode" maxlength="4" autocomplete="off" />
              <div class="codeImg">
                <span @click="getVerify" v-if="codeImg" class="validateCode">
                  <img class="img" :src="codeImg" alt="code" />
                </span>
              </div>
            </div>
            <a class="login-tips" v-if="!isRegisterAction" href="https://www.8day.com">Quên mật khẩu ?</a>
          </section>
          <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" :vstyle="{
              width: '280px',
              height: '96.77px',
              top: '35px'
            }" :nativeButton="{
              width: '100%',
              height: '100%'
            }" @cb="handleConfirm">
            <div v-show="isRegisterAction" class="submitBtn" @click="submitAction(1)">
              <img src="../assets/football/pc/register.png" alt="pic" />
            </div>
          </v-captcha>
          <div v-show="!isRegisterAction" class="submitBtn btn-reg" @click="submitAction(2)">
            <img src="../assets/football/pc/login.png" alt="pic" />
          </div>
        </div>
        <div class="cts">
          <a :href="contacts.facebook" target="_blank">
            <img src="../assets/football/pc/fb.png" />
          </a>
          <a :href="contacts.telegram" target="_blank">
            <img src="../assets/football/pc/tg.png" />
          </a>
        </div>
      </div>
    </div>
    <div class="root" v-if="isMobile">
      <img class="title" src="../assets/football/h5/h5-title.png" />
      <div class="form">
        <div class="tag">
          <div class="tag-item reg" :class="isRegisterAction ? 'reg-active' : ''" @click="isRegisterAction = true">
            <template v-if="!isRegisterAction">ĐĂNG KÝ</template>
          </div>
          <div class="tag-item login" :class="!isRegisterAction ? 'login-active' : ''" @click="isRegisterAction = false">
            <template v-if="isRegisterAction">ĐĂNG NHẬP</template>
          </div>
        </div>
        <div class="h5Content">
          <div class="form-input">
            <img src="../assets/sport/icon-user.png" />
            <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
          </div>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/sport/icon-phone.png" />
            <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
          </div>
          <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
            <img src="../assets/sport/icon-password.png" />
            <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
          </div>
          <div class="form-input" v-show="isRegisterAction">
            <img src="../assets/sport/icon-email.png" />
            <input v-model="form.email" autocomplete="off" placeholder="Email" />
          </div>
          <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;">
            <input v-model="form.verificationCode" maxlength="4" autocomplete="off" />
            <div class="codeImg">
              <span @click="getVerify" v-if="codeImg" class="validateCode">
                <img class="img" :src="codeImg" alt="code" />
              </span>
            </div>
          </div>
          <a v-if="!isRegisterAction" href="https://www.8day.com">Quên mật khẩu ?</a>
        </div>
        <v-captcha ref="vcaptcha2" :dialogVisible="h5DialogVisible" :showCheck="showCheck" :style="{
            width: '100%'
          }" :vstyle="{
            top: '10px'
          }" :nativeButton="{
            width: '129px',
            height: '6vh'
          }" @cb="handleConfirm">
          <div v-show="isRegisterAction" class="btn" @click="submitAction(1)">
            <img src="../assets/football/h5/register.png" alt="pic1" />
          </div>
        </v-captcha>
        <div v-show="!isRegisterAction" class="btn" @click="submitAction(2)">
          <img src="../assets/football/h5/login.png" alt="pic" />
        </div>
      </div>
      <div class="cts">
        <a :href="contacts.facebook" target="_blank">
          <img src="../assets/football/h5/facebook.png" alt="pic" />
        </a>
        <a :href="contacts.telegram" target="_blank">
          <img src="../assets/football/h5/tg.png" alt="pic" />
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import md5 from "js-md5";
import {
  FORM_VALID_MESSAGE,
  DOMAIN_AGENT_CODE,
  CONTRACTS,
  DOMAIN_AGENT_CODE_MAP
} from "../utils/constant";
import { userRegister, userLogin, createCustomer, getCode } from "../utils/request";
import { encodePlatformUrl, validForm, isMobile } from "../utils/tools";
import fa from "element-ui/src/locale/lang/fa";
import { captcha } from "@/mixins/captcha";
export default {
  name: "Football",
  mixins: [captcha],
  computed: {
    fa() {
      return fa;
    }
  },
  data() {
    return {
      codeImg: '',
      isMobile: isMobile(),
      loading: false,
      isRegisterAction: true,
      dialogVisible: false,
      dialogBgi: require("../assets/football/pc/alert-bg.png"),
      closeImg: require("../assets/football/pc/close.png"),
      contacts: CONTRACTS,
      form: {
        by: 1,
        username: "",
        verificationCode: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      errorMsg: {
        title: "",
        content: ""
      },
      h5DialogVisible: false
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    submitAction(type) {
      let errorMsg = validForm(type, this.form);
      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }
      this.loading = true;
      // 登陆
      if (type === 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.userName,
          phone: temp.phone,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode =
          DOMAIN_AGENT_CODE[location.host] ||
          DOMAIN_AGENT_CODE_MAP.get(location.host) ||
          "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.form.username = this.form.userName;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      params.verificationCode = this.form.verificationCode;
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.h5DialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      if (this.isMobile) {
        this.h5DialogVisible = true;
      } else {
        this.dialogVisible = true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-content {
  height: 262px;
  margin: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  p {
    margin: 0;
  }
  .title {
    font-style: normal;
    font-weight: 900;
    font-size: 28px;
    line-height: 35px;
    letter-spacing: 0.05em;
  }
  .text {
    margin-top: 20px;
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
  }
}
.container {
  height: 100vh;
  background-image: url("../assets/football/pc/bg.jpg");
  background-size: 100% 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  img.title {
    margin-top: 50px;
    //position: fixed;
    //top: 50px;
    //left: 50%;
    //transform: translateX(-50%);
  }

  .main {
    margin-top: 20px;
    width: 564px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .form {
      background-image: url("../assets/football/pc/form-bg.png");
      background-size: 100% 100%;
      position: relative;
      width: 100%;
      height: 548px;
      margin: 30px auto 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      .tag {
        width: 501px;
        height: 54px;
        background-image: url("../assets/football/pc/tag-bg.png");
        background-size: 100% 100%;
        margin: 23px 0 35px;
        display: flex;
        align-items: center;
        justify-content: center;

        .tag-item {
          flex: 1;
          color: #ffffff;
          cursor: pointer;
          font-style: italic;
          font-weight: 900;
          font-size: 24px;
          line-height: 29px;
        }

        .active {
          background-size: 100% 100%;
          width: 310px;
          height: 106px;
          position: relative;
          top: -9px;
        }

        .reg-active {
          background-image: url("../assets/football/pc/active-right-tag.png");
          .active;
        }
        .login-active {
          background-image: url("../assets/football/pc/active-left-tag.png");
          .active;
        }
      }

      .form-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 324px;
        .form-input {
          height: 65px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 0 75px 0 20px;
          background-size: 100% 100%;
          transition: all 0.25s ease;
          background-image: url("../assets/football/pc/form-item-bg.png");
          .codeImg {
            cursor: pointer;
            width: 150px;
            height: 96%;
            position: absolute;
            right: 0;
            top: 3px;
            .img {
              width: 150px;
              height: 100%;
              border-radius: 0 25px 25px 0;
            }
          }

          img {
            margin-right: 10px;
          }

          input {
            border: none;
            outline-width: 0;
            background-color: transparent;
            height: 34px;
            width: 300px;
            font-family: UTMAvo;
            font-weight: 500;
            font-size: 25px;
            color: #fff;
            padding: 1px 2px;
          }

          input::placeholder {
            color: #ffffff;
            font-size: 22px;
            font-style: normal;
            font-weight: normal;
          }
        }
        .login-tips {
          font-style: normal;
          font-weight: 600;
          font-size: 20px;
          line-height: 25px;
          color: #fff;
          position: relative;
          top: 30px;
          text-decoration: none;
        }
      }

      .submitBtn {
        width: 280px;
        height: 96.77px;
        margin: 0 auto;
        background-size: 100% 100%;
        position: relative;
        top: 35px;
        cursor: pointer;
        background-image: url("../assets/football/pc/button.png");
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-bottom: 18px;
        }
      }
    }
    .cts {
      width: 711px;
      height: 107px;
      background-image: url("../assets/football/pc/footer.png");
      background-size: 100% 100%;
      text-align: center;
      margin-top: -37px;

      img {
        margin: 0 10px;
        position: relative;
        top: 55px;
      }
    }
  }
}
.root {
  background-image: url("../assets/football/h5/h5-bg.jpg");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  height: 100vh;

  img.title {
    margin-top: 3vh;
    width: 80%;
    margin-bottom: 13vh;
  }

  //p {
  //  font-size: 2em;
  //  font-weight: bold;
  //  margin: 0;
  //  color: #FFFFFF;
  //
  //  img {
  //    width: 40vw;
  //    position: relative;
  //    top: 18px;
  //    left: 10px;
  //  }
  //}

  .form {
    background-image: url("../assets/football/h5/h5-form-bg.png");
    background-size: 100% 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 37.5vh;

    a {
      margin-top: 2vh;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      display: block;
      text-decoration: none;
      color: #fff;
    }

    .tag {
      background-image: url("../assets/football/h5/h5-tag-bg.png");
      background-size: 100% 100%;
      height: 4vh;
      width: 90%;
      margin-top: 1.9vh;
      display: flex;

      .tag-item {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 1em;
        text-align: center;
        font-style: normal;
        font-weight: bold;
      }

      .reg-active {
        background-image: url("../assets/football/h5/reg-active.png");
        background-size: 100% 100%;
        width: 58%;
        height: 7vh;
        position: relative;
        top: -3vh;
      }
      .login-active {
        background-image: url("../assets/football/h5/login-active.png");
        background-size: 100% 100%;
        width: 58%;
        height: 7vh;
        position: relative;
        top: -3vh;
      }
    }

    .h5Content {
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .form-input {
        width: 70%;
        margin: 0 auto 10px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 5px 10px;
        background-size: 100% 100%;
        transition: all 0.25s ease;
        border-radius: 20px;
        background-image: url("../assets/football/h5/h5-form-input-bg.png");
        .codeImg {
          cursor: pointer;
          width: 150px;
          height: 92%;
          position: absolute;
          right: 0;
          top: 3px;
          .img {
            width: 150px;
            height: 100%;
            border-radius: 0 25px 25px 0;
          }
        }

        img {
          margin-right: 10px;
        }

        input {
          font-family: UTMAvo;
          border: none;
          outline-width: 0;
          background-color: transparent;
          height: 34px;
          width: 300px;
          font-size: 1em;
          color: #ffffff;
        }

        input::placeholder {
          color: #ffffff;
          font-size: 1em;
          font-style: normal;
          font-weight: normal;
        }
      }
    }
    .btn {
      width: 43%;
      height: 6vh;
      position: relative;
      top: 2vh;
      background-image: url("../assets/football/h5/button.png");
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      img {
        width: 79%;
        position: relative;
        top: 1vh;
      }
    }
  }

  .cts {
    text-align: center;
    margin-top: 5vh;

    img {
      width: 12vw;
      margin: 0 2vw;
    }
  }

  img.img-btm {
    width: 70%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Football.vue